<template>
  <div v-if="hasTariffs">
    <BasicBtErrorBoundary>
      <TariffTenantOfferList
        :tenantId="tenantId"
        :contractRenewal="false"
        :student="false"
        :contentPageOnly="false"
        :refurbishedHighlights="false"
        :title="'Vodafone - Tarifangebote'"
        :store="currentStore"
        :allMobile="true"
        :mobile="true"
      />
    </BasicBtErrorBoundary>
    <BasicBtErrorBoundary>
      <TariffTenantOfferList
        :tenantId="tenantId"
        :contractRenewal="false"
        :student="false"
        :contentPageOnly="false"
        :refurbishedHighlights="true"
        :title="'Vodafone - Refurbished Highlights'"
        :store="currentStore"
      />
    </BasicBtErrorBoundary>
    <BasicBtErrorBoundary>
      <TariffTenantOfferList
        :tenantId="tenantId"
        :contractRenewal="false"
        :student="true"
        :contentPageOnly="false"
        :title="'Studenten - Tarifangebote'"
        :store="currentStore"
      />
    </BasicBtErrorBoundary>
    <BasicBtErrorBoundary>
      <TariffTenantOfferList
        :tenantId="tenantId"
        :contractRenewal="true"
        :student="false"
        :contentPageOnly="false"
        :title="'Vodafone - Vertragsverlängerungsangebote'"
        :store="currentStore"
      />
    </BasicBtErrorBoundary>
  </div>
  <h1
    v-else
    class="pt-12 pb-12 container mx-auto font-bold text-paragraph text-2xl text-center"
  >
    Aktuell gibt es keine laufenden Vodafone Tarifangebote
  </h1>
</template>

<script setup lang="ts">
import { hasTenantTariffs } from "~/composables/tariffs";

useHead({
  title: "Vodafone Tarifangebote - Top GigaMobil-Deals beim Experten vor Ort",
  meta: [
    {
      name: "description",
      content:
        "Starke Vodafone Tarifangebote mit 5G, Smartphone-Bundles und attraktiven Cashback-Aktionen. Jetzt GigaMobil-Vorteile entdecken und beraten lassen.",
    },
  ],
});

const tenantId: string = "692ef564d1b19b630ac62ff2";
const currentStore = useCurrentStore();
const hasTariffs = ref<boolean>();

const checkHasTariffs = async (storeId: string): Promise<void> => {
  hasTariffs.value = await hasTenantTariffs(tenantId, storeId, {contentPageOnly: false});
};

await checkHasTariffs(currentStore.value?.id);

watch(currentStore, async (store) => {
  const storeId: string = store?.id;
  if (!storeId) {
    return;
  }

  await checkHasTariffs(storeId);
});
</script>
